import React from 'react';
import {
  Button, ModalView, Stack, Text, Trans,
} from '../../../../..';

export const ManagePaymentModal = ({ isLoading, onClose, onConfirm, t }) => (
  <ModalView
    title={t('PaymentFailedBanner.manage-payment-modal.title')}
    onClose={onClose}
    actions={(
      <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
        <Button text={t('cancel')} appearance="default" onClick={onClose} />
        <Button text={t('PaymentFailedBanner.manage-payment-modal.redirect-button-text')} pending={isLoading} appearance="primary" onClick={onConfirm} />
      </Stack>
    )}
  >
    <Stack vertical spacing="narrow">
      <Stack.Item>
        <Text>
          <Trans
            t={t}
            i18nKey="PaymentFailedBanner.manage-payment-modal.description-line-1"
            components={[
              <b>text</b>,
            ]}
          />
        </Text>
      </Stack.Item>
      <Stack.Item>
        <Text>{t('PaymentFailedBanner.manage-payment-modal.description-line-2')}</Text>
      </Stack.Item>
    </Stack>
  </ModalView>
);
